module.exports = __webpack_public_path__ + "src/assets/img/lighter.b48b2398.png";